const helpers = {
  commaSeparatedList(arr) {
    const list = []
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] !== undefined && arr[i] !== null) {
        list.push(arr[i])
      }
    }
    return list.join(', ')
  },
}
export default helpers
